import React, { useEffect, useRef, useState } from 'react';
import styled from '@emotion/styled';
import colors, { white } from '../../../../theme/colors';
import DashboardDiscoverModeCrossIcon from '../icons/DashboardDiscoverModeCrossIcon';
import { ContainerWrapperProps } from './types/DashboardDiscoverModePassFlag';
import { isDarkMode } from '../../../../utils/helpers';
import breakpoints from '../../../../theme/material/breakpoints';

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const ContainerWrapper = styled('div')(({ topPosition, isVisible }: ContainerWrapperProps) => () => {
  const theme = isDarkMode() ? 'dark' : 'light';

  return {
    display: 'inline-flex',
    padding: '11px 20px',
    alignItems: 'center',
    gap: 5,
    borderRadius: 15,
    border: `3px solid ${colors[theme].red.primary}`,
    background: white,
    position: 'absolute',
    left: 10,
    top: topPosition,
    opacity: isVisible ? 0.8 : 1,
    transition: 'top 0.5s ease-in-out, opacity 0.5s ease-in-out',
    [breakpoints.up(769)]: {
      left: 20,
    },
  };
});

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const PassTextWrapper = styled('div')(() => {
  const theme = isDarkMode() ? 'dark' : 'light';

  return {
    color: colors[theme].red.primary,
    textAlign: 'center',
    fontSize: 22,
    fontStyle: 'normal',
    fontWeight: 700,
    letterSpacing: -0.44,
  };
});

interface Props {
  onHidden: () => void;
}

const DashboardDiscoverModePassFlag: React.FC<Props> = ({ onHidden }) => {
  const [topPosition, setTopPosition] = useState(30);
  const [isVisible, setIsVisible] = useState(true);
  const hideTimeoutRef = useRef<number | null>(null);

  useEffect(() => {
    const animationTimeout = setTimeout(() => {
      setTopPosition(10);
      setIsVisible(false);

      // Additional delay before hiding (adjust as needed)
      hideTimeoutRef.current = window.setTimeout(() => {
        onHidden();
      }, 800);
    }, 0);

    return () => {
      clearTimeout(animationTimeout);
      if (hideTimeoutRef.current) {
        clearTimeout(hideTimeoutRef.current);
      }
    };
  }, [onHidden]);

  return (
    <ContainerWrapper
      // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
      topPosition={topPosition}
      isVisible={isVisible}
    >
      <DashboardDiscoverModeCrossIcon />
      <PassTextWrapper>NOPE!</PassTextWrapper>
    </ContainerWrapper>
  );
};

export default DashboardDiscoverModePassFlag;
